import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import React, { FC } from "react";

interface ListFormatProps {
  value: string[];
}

const ListFormat: FC<ListFormatProps> = ({ value }) => (
  <List>
    {value.map((listItem, idx) => (
      <ListItem key={idx}>
        <ListItemText primary={listItem} />
      </ListItem>
    ))}
  </List>
);

export { ListFormat };
